@if (ratingTitle) {
  <section class="Feedback__Rating">
    <p class="Feedback__RatingTitle">{{ ratingTitle }}</p>
    @if (iconList) {
      <section>
        <div class="Feedback__RatingIcons">
          @for (icon of iconList; track icon; let i = $index) {
            <i
              data-test-id="feedbackRatingIcons"
              [class]="icon.class"
              (keyup.space)="changeIcons(i)"
              (click)="changeIcons(i)"
            >
              {{ icon.text }}
            </i>
          }
        </div>
      </section>
    }
  </section>
}
